import { USCurrency } from 'components/ReusableComponents/FormattedPrice'
import moment from 'moment'

import additionalCharges from './additionalCharges.json'
import styles from './BillableItems.module.scss'

export const billableItemTexts = {
  Unknown: 'Unknown',
  PaymentCore: 'Payment core',
  MarketingWithCommission: 'Marketing with commission',
  Marketing: 'Marketing',
  ReviewInvite: 'Review invite',
  Messaging: 'Messaging',
  PlatformAccessFee: 'Platform access fee',
  SetupFee: 'Setup fee',
  DirectfulCore: 'Directful core',
  Basic: 'In-property basic',
  Unlimited: 'Directful unlimited',
  PremiumSupport: 'Premium support'
}

const filterSubscriptions = subscriptions => {
  if (!subscriptions || subscriptions.length === 0) return []

  const hasUnlimitedPlan = subscriptions.some(s => s.plan === 'Unlimited')

  return subscriptions.filter(s => !(hasUnlimitedPlan && s.plan === 'DirectfulCore'))
}

const BillableItems = ({ invoiceDetails, isLegacyInvoice }) => {
  const {
    totalFixedServices,
    totalMessageFees,
    beginDate,
    endDate,
    customMessagesBeginDate,
    customMessagesEndDate,
    subsidiarySubscriptions,
    subsidiaryInvoiceId
  } = invoiceDetails

  if (!totalFixedServices && !totalMessageFees) return null

  const shouldDisplayDate = s => s.plan !== 'SetupFee' && s.startDate && s.endDate

  const shouldNotFilterSubscriptions = subscriptions => {
    if (!subscriptions || subscriptions.length === 0) return []

    const hasUnlimitedPlan = subscriptions.some(s => s.plan === 'Unlimited')

    const hasDirectfulCorePlanRate = subscriptions.some(
      s => s.plan === 'DirectfulCore' && s.planRate > 0
    )

    return hasUnlimitedPlan && hasDirectfulCorePlanRate
  }

  const filteredSubscriptions = shouldNotFilterSubscriptions(subsidiarySubscriptions)
    ? subsidiarySubscriptions
    : filterSubscriptions(subsidiarySubscriptions)

  return (
    <div className={styles.billableItems}>
      <p className={styles.billableItemsTitle}>Billable items</p>
      {additionalCharges[subsidiaryInvoiceId]?.map(charge => (
        <div className={styles.billableItemDarker}>
          <div className={styles.billableItemText}>
            <p className={styles.billableItemTitle}>{charge.title}</p>
            <p className={styles.billableItemDescription}>{charge.description}</p>
          </div>
          {charge.amount && (
            <div className={styles.billableItemPrice}>
              <USCurrency withCode>{charge.amount}</USCurrency>
            </div>
          )}
        </div>
      ))}
      {isLegacyInvoice
        ? totalFixedServices > 0 && (
            <div className={styles.billableItem}>
              <div className={styles.billableItemText}>
                <p className={styles.billableItemTitle}>Directful core services</p>
                <p className={styles.billableItemDescription}>
                  For {moment(beginDate).format('MMM DD, YYYY')} -{' '}
                  {moment(endDate).format('MMM DD, YYYY')}
                </p>
              </div>
              <div className={styles.billableItemPrice}>
                <USCurrency withCode>{totalFixedServices}</USCurrency>
              </div>
            </div>
          )
        : filteredSubscriptions.length > 0 &&
          filteredSubscriptions.map(s => (
            <div className={styles.billableItem}>
              <div className={styles.billableItemText}>
                <p className={styles.billableItemTitle}>{billableItemTexts[s.plan]}</p>
                {shouldDisplayDate(s) ? (
                  <p className={styles.billableItemDescription}>
                    For {s.startDate ? moment(s.startDate).format('MMM DD, YYYY') : 'N/A'}{' '}
                    - {s.endDate ? moment(s.endDate).format('MMM DD, YYYY') : ''}
                  </p>
                ) : null}
              </div>
              <div className={styles.billableItemPrice}>
                <USCurrency withCode>{s.planRate}</USCurrency>
              </div>
            </div>
          ))}
      {totalMessageFees > 0 && (
        <div className={styles.billableItem}>
          <div className={styles.billableItemText}>
            <p className={styles.billableItemTitle}>Drip campaigns</p>
            <p className={styles.billableItemDescription}>
              For {moment(customMessagesBeginDate).format('MMM DD, YYYY')} -{' '}
              {moment(customMessagesEndDate).format('MMM DD, YYYY')}
            </p>
          </div>
          <div className={styles.billableItemPrice}>
            <USCurrency withCode>{totalMessageFees}</USCurrency>
          </div>
        </div>
      )}
    </div>
  )
}

export default BillableItems
